//
//
//
//
//
//
//
//
//
//
//

  export default {
    type: 'component',
    props: {
      img: {
        type: String,
        default: '/static/img/NullData.png'
      },
      text: {
        type: String
      },
      btnText: {
        type: String
      },
      type: {
        type: String,
        default: "page"
      },
      imgStyle: {
        type: String,
        default: "width: 266px; height: 170px;"
      }
    },
//  components: {
//    imageFit
//  },
    methods: {
      onPress() {
        this.$emit("btn-on-press");
      }
    }
  };



// WEBPACK FOOTER //
// ./src/components/app/empty-view/index.vue